<template>
  <b-tooltip
    id="tooltip"
    type="is-black"
    :position="position"
    :label="content"
    :always="isVisible"
    :style="styleObject">
  </b-tooltip>
</template>

<script>

const offset = [10, 10]

export default {
  props: {
    layer: Object
  },
  data () {
    return {
      isVisible: false,
      position: 'is-right',
      content: '',
      styleObject: {
        left: offset[0] + 'px',
        top: offset[1] + '10px'
      }
    }
  },
  mounted () {
    this.$map.hover({
      minZoom: this.$conf.tilesets.select.minZoom,
      maxZoom: this.$conf.tilesets.select.maxZoom,
      cb: (feature, px) => {
        if (feature) {
          this.styleObject = {
            left: (px[0] + offset[0]) + 'px',
            top: (px[1] + offset[1]) + 'px'
          }
          this.content = feature.get('id')
          this.isVisible = true
        } else {
          this.isVisible = false
        }
      }
    })
  }
}

</script>

<style lang="stylus" scoped>

#tooltip
  position: absolute



</style>
